import catalogos from './catalogos/sicpo'
import funciones from './funcion/funcion'
import sistema from './sistema/sicpo'

const sicpo = {
  catalogos: catalogos,
  funcion: funciones,
  sistema: sistema
}

export default sicpo



//////////////////
// WEBPACK FOOTER
// ./static/js/api/SICPO/sicpoapi.js
// module id = null
// module chunks = 